module.exports = __webpack_public_path__ + "img/20241216_1826_dbLogo.eb87e481.png";